import { useTranslation } from 'react-i18next';
import type { CreateDataRequestDto } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormFileMultiple } =
  typedFormFields<CreateDataRequestDto>();

export function Attachment() {
  // Wil je nog extra bestanden meesturen?
  const { t } = useTranslation('dataRequest');

  return (
    <ConditionalField
      field="attachments"
      condition={(formValue) =>
        !!formValue('periods') ||
        (!!formValue('periodNote') && formValue('periodNote')!.length > 2)
      }
    >
      <FormFileMultiple
        label={t('attachment')}
        name="attachments"
        rules={{ required: false }}
      />
    </ConditionalField>
  );
}
